<template>
  <div class="large-page">
    <breadcrumbs>
      <div class="d-flex flex-wrap flex-grow-1 justify-end align-center">
        <v-btn
          depressed
          color="white"
          @click="fetchItems"
        >
          <v-icon color="bluegray" left>
            refresh
          </v-icon>

          Refresh
        </v-btn>
      </div>
    </breadcrumbs>

    <template v-if="apiResponse">
      <v-data-table
        disable-pagination
        hide-default-footer
        class="mt-4 box-shadow-soft"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th>
                Name
              </th>

              <th>
                Email
              </th>

              <th>
                Balance
              </th>

              <th>
                Total Credits Added
              </th>

              <th class="text-end">
                Action
              </th>
            </tr>
          </thead>
        </template>

        <template v-slot:body>
          <tbody>
            <tr>
              <td>
                {{ apiResponse.user.name }}
              </td>

              <td>
                {{ apiResponse.user.email }}
              </td>

              <td>
                {{ Number(apiResponse.user.balance) / constants.conversionRate }}
              </td>

              <td>
                {{ Number(apiResponse.user.allTimeCredits) / constants.conversionRate }}
              </td>

              <td class="text-end">
                <v-btn
                  small
                  depressed
                  color="primary"
                  @click="$router.push({ name: `${prefix}/Edit`, params: { userId: apiResponse.user.id } })"
                >
                  Edit
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <v-data-table
        :headers="tableHeaders"
        :items="tableItems"
        class="mt-4 box-shadow-soft"
      >
        <template v-slot:item.influencer_discovery="{ item }">
          {{ Number(item.influencer_discovery) / constants.conversionRate }}
        </template>

        <template v-slot:item.influencer_insight="{ item }">
          {{ Number(item.influencer_insight) / constants.conversionRate }}
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
// Import the breadcrumb component for routes
const Breadcrumbs = () => import("@/components/common/Breadcrumbs.vue")

// Export the SFC
export default {
  // Name of the component
  name: "UsageByMonth",

  // Register the components
  components: {
    Breadcrumbs
  },

  // Accept incoming props from parent
  props: {
    // The network URL to make request to
    endpoint: String,
    // Toe prefix for routes
    prefix: String
  },

  // Define local data variables
  data: () => ({
    isLoading: true,
    searchQuery: "",
    apiResponse: null,

    tableHeaders: [
      {
        text: "Month",
        value: "month",
        sortable: true,
        sort: (a, b) => {
          return dayjs(a, "MMMM YYYY").unix() - dayjs(b, "MMMM YYYY").unix()
        }
      },
      {
        text: "Influencer Discovery",
        value: "influencer_discovery",
        sortable: true
      },
      {
        text: "Influencer Insight",
        value: "influencer_insight",
        sortable: true
      }
    ]
  }),

  computed: {
    tableItems() {
      const items = []

      // If API response exists
      if (this.apiResponse) {
        // Go through credit for values (influencer-discovery and influencer-insight)
        for (const key in this.apiResponse.transactions) {
          // Now go through each of the monthly record
          for (const record of this.apiResponse.transactions[key]) {
            // Compute the date string from month and year
            const month = dayjs(`01-${String(record.month).padStart(2, "0")}-${record.year}`, "DD-MM-YYYY").format("MMMM YYYY")

            // Try to find out if it exists in items or not
            const index = items.findIndex((search) => search.month === month)

            // If found, modify it's value
            if (index !== -1) {
              items[index][key.replace("-", "_")] = record.amount
            }
            // Otherwise push the entire item in it
            else {
              const item = {
                month,
                "influencer_discovery": 0,
                "influencer_insight": 0
              }

              item[key.replace("-", "_")] = record.amount

              items.push(item)
            }
          }
        }
      }

      return items
    }
  },

  methods: {
    async fetchItems() {
      this.isLoading = true

      const loaderId = Symbol()
      this.$store.dispatch("loaders/add", loaderId)

      try {
        const response = await axios({
          url:  `${this.endpoint}/${this.$route.params.userId}`,
        })

        this.apiResponse = response.data
      } catch (error) {
        logger({ type: "Credit Usage By Month Fetch Error", error })

        this.$store.dispatch("toasts/add", { text: "An error occurred!" })
      } finally {
        this.isLoading = false

        this.$store.dispatch("loaders/remove", loaderId)
      }
    }
  },

  mounted() {
    this.fetchItems()
  }
}
</script>

<style lang="stylus" scoped>
.search-input
  max-width 20em
</style>
